import { createQueryHook } from "@accurx/api/QueryClient";
import { httpClient2 } from "@accurx/shared";

import {
    PracticeDetailsDto,
    PracticeModules,
} from "app/practices/Practices.types";

export const WORKSPACE_MODULES_CACHE_KEY = "WorkspaceModules";

type WorkspaceModulesQueryVariables = {
    workspaceId: number;
};

export const useWorkspaceModulesQuery = createQueryHook<
    WorkspaceModulesQueryVariables,
    PracticeModules | undefined
>(({ workspaceId }) => ({
    queryKey: [WORKSPACE_MODULES_CACHE_KEY, { workspaceId }],
    queryFn: async () => {
        const practices = await httpClient2
            .get({ path: "/api/portal/practices" })
            .json<PracticeDetailsDto[]>();
        const practice = practices.find(
            (practice) => practice.id === workspaceId,
        );
        return practice?.modules;
    },
}));
